import { LocalDepartments } from '../../../../../../types/nafLocations';
import { CenterType } from '../../../../../../types/centerType';
import {
  getUserLocation,
  fetchNearbyCenters as fetchNearbyCentersRaw,
  formatDistance,
} from '../../../nafCenter/services/CenterSelect/CenterSelect.utils';

export { formatDistance };

export const findNearbyCenters = async (): Promise<LocalDepartments[]> => {
  const position = await getUserLocation();
  const { latitude, longitude } = position.coords;
  const nearbyCenters = await fetchNearbyCentersRaw(latitude, longitude);

  if (!nearbyCenters || nearbyCenters.length === 0) {
    return [];
  }

  const groupedByCounty = nearbyCenters.reduce((acc: Record<string, LocalDepartments>, center: CenterType) => {
    const countySlug = center.county?.slug || 'unknown';

    if (!acc[countySlug]) {
      acc[countySlug] = {
        county: {
          total: 1,
          name: center.county?.name || '',
          slug: countySlug,
        },
        nafLocations: [],
      };
    } else {
      acc[countySlug].county.total += 1;
    }

    acc[countySlug].nafLocations.push(center);

    return acc;
  }, {});

  return Object.values(groupedByCounty);
};
